import Icon from '@/components/Icon/Icon';
import { HStack, VStack } from '@/components/Layout';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import type { AppUser } from '@/features/app-user/types/appUser';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { genNameInitials } from '@/utils/name';
interface Props {
  appUser: AppUser | null | undefined;
  subtitle?: string;
}

// AppUserを表示するセル
const AppUserCell = ({
  appUser,
  subtitle
}: Props) => {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'component.dataTable.cells.AppUserCell'
  });
  if (!appUser) {
    return <Icon iconName="UserRoundSearchIcon" text={t('noUser')} variant="small" colorVariant="error" textColor="text-error-on-neutral-fill" />;
  }
  return <HStack className="items-center gap-3">
      <Avatar>
        <AvatarImage className="object-contain" src={appUser?.avatarUrl} />
        <AvatarFallback>
          {appUser?.nameInitials ? appUser.nameInitials : genNameInitials(appUser.name ?? '')}
        </AvatarFallback>
      </Avatar>
      <VStack className="gap-1 p-2">
        <VStack className="text-sm font-bold">
          {appUser.name || t('noName')}
        </VStack>
        <VStack className="text-sm text-neutral-muted-on-fill">
          {subtitle || appUser?.email}
        </VStack>
      </VStack>
    </HStack>;
};
export default AppUserCell;